<template>
  <div class="flex justify-between mt-5 mb-3">
    <Button label="Atras"
            icon="pi pi-arrow-left"
            class="mr-2 p-button-danger"
            @click="$router.go(-1)"
    />
  </div>

  <form @submit="onSubmit">
    <div class="mb-2">
      <label for="observaciones">Observaciones</label>
      <InputText
        v-model="model.observaciones"
        id="observaciones"
        type="text"
        class="form-control"
      />
      <div class="text-red-400">
        {{errors.observaciones}}
      </div>
    </div>

    <div class="mb-2">
      <label for="fechaInicio">Fecha Inicio</label>
      <Calendar id="fechaInicio" v-model="model.fechaInicio" autocomplete="off" class="w-full" />
      <div class="text-red-400">
        {{errors.fechaInicio}}
      </div>
    </div>

    <div class="mb-2">
      <label for="fechaFin">Fecha Fin</label>
      <Calendar id="fechaFin" v-model="model.fechaFin" autocomplete="off" class="w-full" />
      <div class="text-red-400">
        {{errors.fechaFin}}
      </div>
    </div>

    <div class="mb-2">
      <label for="responsable">Reponsable</label>
      <Dropdown v-model="model.responsable"
                id="responsable"
                :options="optionsUsers"
                optionLabel="fullName"
                optionValue="id"
                :filter="true"
                filterPlaceholder="Buscar"
                class="w-full"
      />
      <div class="text-red-400">
        {{errors.responsable}}
      </div>
    </div>

    <div class="mb-2">
      <Button label="Guardar"
              icon="pi pi-plus"
              class="mr-2 p-button-success"
              type="submit"
      />
    </div>
  </form>

  <Toast/>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useField, useForm } from 'vee-validate'
import { object, string, date, number } from 'yup'
import LicUsersService from '@/apps/pharmasan/licitaciones/services/LicUsersService'
import LicTareasService from '@/apps/pharmasan/licitaciones/services/LicTareasService'
import Swal from 'sweetalert2'

export default {
  name: 'TareasCrear',
  setup () {
    onMounted(() => {
      getUsuarios()
    })
    // Variables
    const _LicUsersService = ref(new LicUsersService())
    const _LicTareasService = ref(new LicTareasService())
    const validationSchema = object().shape({
      observaciones: string().required().min(3).typeError('Observaciones es requerido'),
      fechaInicio: date().required().typeError('Fecha Inicio es requerido'),
      fechaFin: date().required().typeError('Fecha Fin es requerido'),
      responsable: number().required().min(3).typeError('Responsable es requerido')
    })
    const { values: model, errors, handleSubmit, handleReset } = useForm({
      validationSchema
    })
    useField('observaciones', null, { initialValue: '' })
    useField('fechaInicio', null, { initialValue: '' })
    useField('fechaFin', null, { initialValue: '' })
    useField('responsable', null, { initialValue: '' })
    const optionsUsers = ref([])
    const router = useRouter()
    const route = useRoute()

    // Methods
    const getUsuarios = () => {
      _LicUsersService.value.getUsers().then(({ data }) => {
        optionsUsers.value.push(...data)
      })
    }

    const onSubmit = handleSubmit((values) => {
      values.estado = 0
      values.licCarpetasDocumentosId = route.params.id
      _LicTareasService.value.saveTarea(values).then((data) => {
        if (data.status === 200) {
          Swal.fire({
            title: 'Exito',
            text: 'Tarea creada con éxito',
            icon: 'success',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Ok'
          }).then((result) => {
            if (result.isConfirmed) {
              handleReset()
              router.go(-1)
            }
          })
        } else {
          console.log(data)
        }
      })
    })

    return {
      model,
      errors,
      onSubmit,
      optionsUsers
    }
  }
}
</script>

<style scoped>

</style>
